import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import ReactSelect from '../../../../Shared/ReactSelect/ReactSelect';
import TextInput from '../../../../Shared/TextInput/TextInput';
import {Container, Row, Col, Button} from 'reactstrap';
import SearchResultComponent from '../../SearchAbroadPackage/SearchResultComponent';
import {connect} from 'react-redux';
import {
  abroadCountriesSearched,
  setSearchCountryResults,
  setCurrentCountryDataToShow,
  getRetrieveTariffPrices,
} from '../../cellcomAbroadBlockSlice';
import images from '../images/images';
import lobbyImages from '../../LobbyTabs/images/images';
import './CountryPopUp.scss';
import SelectAndSearch from './SelectAndSearch';
import {gaEvent} from '../../../../../utilities/analytics/tracking';
import gaParams from '../../../../../utilities/analytics/constants';
import AbroadPackageTab from '../../Shared/Components/AbroadPackageTab';
import ImportantPart from '../../Shared/Components/ImportantPart';
import {isMobile, isBrowser} from 'react-device-detect';

const CountryPopUp = ({
  abroadCountriesSearched,
  searchCountryResults,
  onClose,
  setCurrentCountryDataToShow,
  chosenCountry,
  businessId,
  privateId,
  packageSocCode,
  getRetrieveTariffPrices,
  singleCountryUsageData,
}) => {
  const [searchValue, setSearchValue] = useState(chosenCountry);
  const [expendedImportantInfo, setExpendedImportantInfo] = useState(false);

  useEffect(() => {
    gaEvent(
      gaParams.ABROAD_MY_ABROAD_CLICK_POP_UP_DISPLAY_COUNTRIES.category,
      gaParams.ABROAD_MY_ABROAD_CLICK_POP_UP_DISPLAY_COUNTRIES.eventType,
      gaParams.ABROAD_MY_ABROAD_CLICK_POP_UP_DISPLAY_COUNTRIES.eventParams
    );
  }, []);

  useEffect(() => {
    if (chosenCountry) {
      gaEvent(
        gaParams.ABROAD_MY_ABROAD_CLICK_POP_UP_DISPLAY_COUNTRIES_PICK_COUNTRY.category,
        gaParams.ABROAD_MY_ABROAD_CLICK_POP_UP_DISPLAY_COUNTRIES_PICK_COUNTRY.eventType,
        chosenCountry
      );
      const countryObj = searchCountryResults.filter((c) => c.countryHebName === chosenCountry);
      const data = {
        country: countryObj[0].countryCode,
        soc: packageSocCode,
        blockId: privateId || businessId || '',
      };
      getRetrieveTariffPrices(data);
    }
  }, [chosenCountry]);

  useEffect(() => {
    return () => {
      setCurrentCountryDataToShow('');
    };
  }, []);

  const searchCountries = (value) => {
    setSearchValue(value);
    if (value && value.trim()) {
      abroadCountriesSearched(value);
    }
  };

  function goBack() {
    gaEvent(
      gaParams.ABROAD_MY_ABROAD_CLICK_POP_UP_DISPLAY_COUNTRIES_CLICK_GO_BACK.category,
      gaParams.ABROAD_MY_ABROAD_CLICK_POP_UP_DISPLAY_COUNTRIES_CLICK_GO_BACK.eventType,
      gaParams.ABROAD_MY_ABROAD_CLICK_POP_UP_DISPLAY_COUNTRIES_CLICK_GO_BACK.eventParams
    );
    setCurrentCountryDataToShow('');
    onClose();
  }

  const EmptySearchResult = (searchValue) => {
    const p1 = 'זה כנראה יעד סופר אקזוטי שאפילו לא';
    const p2 = ' מצאנו אותו במפה';
    const p3 = ' נסו לחפש שוב :)';

    if (searchValue == '') return null;

    return (
      <Container className='empty-search-result'>
        <Row>
          <Col className='text-center'>
            <Image src={lobbyImages.point} alt='icon' />
          </Col>
        </Row>
        <Row>
          <Col className='text-center'>
            <span className='newPurple'>{p1}</span>
            <br />
            <span className='newPurple'>
              {p2}
              <span span className='bold'>
                {p3}
              </span>
            </span>
          </Col>
        </Row>
      </Container>
    );
  };

  function expandImportantToKnow() {
    gaEvent(
      gaParams.ABROAD_MY_ABROAD_CLICK_POP_UP_CLICK_DISPLAY_EXTRA_INFO.category,
      gaParams.ABROAD_MY_ABROAD_CLICK_POP_UP_CLICK_DISPLAY_EXTRA_INFO.eventType,
      gaParams.ABROAD_MY_ABROAD_CLICK_POP_UP_CLICK_DISPLAY_EXTRA_INFO.eventParams
    );
    setExpendedImportantInfo(!expendedImportantInfo);
  }

  function renderSign() {
    return !expendedImportantInfo ? '+' : 'x';
  }

  function renderDataUsageForCountry(searchValue) {
    const searchCountryResultsHasValues = searchCountryResults && searchCountryResults.length > 0;
    if (searchCountryResultsHasValues && chosenCountry && searchCountryResults.some((c) => c.countryHebName === searchValue)) {
      const singlePackageData = singleCountryUsageData?.item1 && singleCountryUsageData?.item1[0];
      const singleCountryExtraInfo = singleCountryUsageData?.item2 || [];
      const voice = singlePackageData && singlePackageData.voice ? singlePackageData.voice?.priceByUsage : '';
      const sms = singlePackageData && singlePackageData.sms ? singlePackageData.sms?.priceByUsage : '';
      const data = singlePackageData && singlePackageData.data ? singlePackageData.data?.priceByUsage : '';
      const dataUnit = singlePackageData && singlePackageData.data ? singlePackageData.data?.unit : '';
      const quantity = singlePackageData && singlePackageData.data ? singlePackageData.data?.quantity : '';
      const priceByUsage = singlePackageData?.data ? singlePackageData.data.priceByUsage : '';

      const singleCountryExtraInfoTxt =
        Array.isArray(singleCountryExtraInfo) && singleCountryExtraInfo.length > 0 ? singleCountryExtraInfo.join(' ') : '';
      return (
        <div className='usage-data-per-country-container'>
          <div className='usage-header'>{`תעריפים ל${chosenCountry} `}</div>
          <div className='data-usage-box'>
            {voice && <div className='data-line'>{`שיחות: ₪${voice} לדקה`}</div>}
            {sms && <div className='data-line'>{`סמס: ₪${sms} להודעה`}</div>}
            {data || dataUnit ? (
              <div className='data-line'>
                {` גלישה: ${quantity}MB `}
                {dataUnit && 'ליום '}
                {priceByUsage && (
                  <>
                    ב-<span>&#8362;</span>
                    {priceByUsage}
                  </>
                )}
              </div>
            ) : null}
          </div>
          {singleCountryExtraInfo && (
            <div className='important-to-know-container'>
              {singleCountryExtraInfo && (
                <div className='important-to-know'>
                  <div className='txt'>חשוב לדעת</div>
                  <div className='plus' onClick={() => expandImportantToKnow()}>
                    {renderSign()}
                  </div>
                </div>
              )}
              {expendedImportantInfo && <p className='important-info-paragraph'>{singleCountryExtraInfoTxt}</p>}
            </div>
          )}
        </div>
      );
    }
  }

  return (
    <div className='country-pop-up-container'>
      {isBrowser ? (
        <div className='header'>בדיקת תעריף לפי מדינה</div>
      ) : (
        <div className='header'>
          בדיקת תעריף
          <br /> לפי מדינה
        </div>
      )}
      <div className='subHeader'>אנא בחר מדינה</div>
      <div className='container p-0'>
        <SelectAndSearch
          countries={searchCountryResults}
          onChange={(val) => searchCountries(val)}
          placeholder={'חפשו יעד'}
          EmptySearchResult={EmptySearchResult}
          setExpendedImportantInfo={setExpendedImportantInfo}
        />
        {chosenCountry && renderDataUsageForCountry(chosenCountry)}
      </div>
      <BtnSubmit onclick={goBack} text={`אוקיי, תודה`} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  searchCountryResults: state.cellcomAbroad.searchCountryResults,
  popularCountries: state.cellcomAbroad.popularCountries,
  chosenCountry: state.cellcomAbroad.currentCountryDataToShow,
  businessId: state.cellcomAbroad.epiStyleInitializationData.businessSocPackageFolderId,
  privateId: state.cellcomAbroad.epiStyleInitializationData.privateSocPackageFolderId,
  singleCountryUsageData: state.cellcomAbroad.singleCountryUsageData,
});

const mapDispatchToProps = {
  abroadCountriesSearched,
  setSearchCountryResults,
  setCurrentCountryDataToShow,
  getRetrieveTariffPrices,
};

export default connect(mapStateToProps, mapDispatchToProps)(CountryPopUp);
